import { format } from "date-fns";
import idLocale from "date-fns/locale/id";

export const regularTime = (time, isFull) => {
  if (isFull) {
    return format(new Date(time), "dd MMMM yyyy HH:mm", {
      locale: idLocale,
    });
  }
  return format(new Date(time), "HH:mm", {
    locale: idLocale,
  });
};

export const regularDate = (date, type = "full") => {
  if (type === "dash") {
    return format(new Date(date), "dd-MM-yyyy");
  } else if (type === "slash") {
    return format(new Date(date), "dd/MM/yyyy");
  }
  return format(new Date(date), "dd MMMM yyyy", {
    locale: idLocale,
  });
};

export const reportDateFormat = (date, isDateStart) => {
  let DATE_FORMAT = "yyyy-MM-dd 00:00:00";
  if (!isDateStart) {
    DATE_FORMAT = "yyyy-MM-dd 23:59:59";
  }
  if (date === null) return undefined;
  return date !== undefined
    ? format(date, DATE_FORMAT, {
        locale: idLocale,
      })
    : undefined;
};

export const reverseDate = (date) => {
  return format(new Date(date), "yyyy-MM-dd");
};
